import React from 'react'
import { Helmet } from 'react-helmet'
import TopBanner from '../components/top-banner'
import Navbar from '../components/navbar'
import CancellationPolicy from '../components/cancellation-policy'
import Footer from '../components/footer'
import SocialMediaFixed from '../components/socialmedia-fixed'

const CancellationPolicyPage = () => {
    return (
        <>
            <Helmet>
                <title>Cancellation Policy - MP Holidays</title>
                <meta name="description" content="Review the cancellation policy for bookings at MP Holidays. Learn about our terms and conditions for cancellations, refunds, and booking adjustments to make your travel planning easier." />
                <meta name="keywords" content="MP Holidays cancellation policy, hotel cancellation terms, hotel booking cancellation, MP Holidays refunds, hotel reservation cancellation, booking terms and conditions, cancellation policy MP Holidays, booking adjustments, package booking refunds" />
                <link rel="canonical" href="https://mpholidays.online/cancellation-policy" />

                {/* JSON-LD structured data */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Hotel",
                        "name": "Cancellation Policy - MP Holidays",
                        "telephone": "+91-9319184060",
                        "url": "https://mpholidays.online/cancellation-policy"
                    })}
                </script>
            </Helmet>

            {<TopBanner />}
            {<Navbar />}
            {<CancellationPolicy />}
            {<Footer />}
            {<SocialMediaFixed />}
        </>
    )
}

export default CancellationPolicyPage
